import { ShieldCheck, CreditCard, Lock } from "lucide-react";
import PaymentMethods from "@/components/checkout/payment-methods";
import { useTranslation } from "react-i18next";

export default function SecurityHeader() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <PaymentMethods />

      {/* Security Badges */}
      <div className="flex items-center justify-center flex-wrap gap-x-3 text-gray-600">
        <div className="flex items-center gap-1.5">
          <Lock className="h-4 w-4" />
          <span className="text-xs font-medium whitespace-nowrap">
            {t("securityHeader.sslSecurity")}
          </span>
        </div>
        <span className="text-border">|</span>
        <div className="flex items-center gap-1.5">
          <ShieldCheck className="h-4 w-4" />
          <span className="text-xs font-medium whitespace-nowrap">
            {t("securityHeader.encryptedPayment")}
          </span>
        </div>
        <span className="text-border">|</span>
        <div className="flex items-center gap-1.5">
          <CreditCard className="h-4 w-4" />
          <span className="text-xs font-medium whitespace-nowrap">
            {t("securityHeader.trustedPayment")}
          </span>
        </div>
      </div>
    </div>
  );
}
